import TagManager from 'react-gtm-module';
import config from '../config';
import {GTM_CONSTANTS} from '../constants'

export const initializeEventTracking = () => {

    TagManager.initialize({
        gtmId: config.googleTagManagerId 
    });
};

export const eventTrackingHelper = (type) => {

    TagManager.dataLayer({
        // event and eventAction needs to be same
        dataLayer: {
            event: GTM_CONSTANTS.CATEGORY,
            eventCategory: GTM_CONSTANTS.CATEGORY,
            eventAction: type === "enquiry" ? GTM_CONSTANTS.ENQUIRY_ACTION : GTM_CONSTANTS.CALCULATION_ACTION ,
            eventLabel:GTM_CONSTANTS.LABEL,
        },
    });
};
